import { useRef, useState } from 'react';
import copy from 'clipboard-copy';
import classNames from 'classnames';
import RoundedButtonPrimary from '../rounded-button-primary/RoundedButtonPrimary';
import styles from './copy-link-button.module.less';

const CopyLinkButton = ({ link, className = '', callback = () => {} }) => {
    const [hasCopiedLink, setHasCopiedLink] = useState(false);
    const addHasCopiedLinkText = () => {
        setHasCopiedLink(true);
        setTimeout(() => setHasCopiedLink(false), 3 * 1000);
    };

    const textElement = useRef(null);
    return (
        <div className={[styles.wrapper, className].join(' ')}>
            <div className={styles.inputAndButtonContainer}>
                <input
                    className={styles.linkInputField}
                    onFocus={() => textElement.current.select()}
                    value={link}
                    readOnly
                    ref={textElement}
                />
                <RoundedButtonPrimary
                    className={styles.copyButton}
                    onClick={() => {
                        copy(link);
                        addHasCopiedLinkText();
                        callback();
                    }}
                >
                    <i className={classNames('fa-solid fa-link', styles.linkIcon)} title="Kopier lenken" />
                    Kopier
                </RoundedButtonPrimary>
            </div>
            <div
                hidden={!hasCopiedLink}
                aria-hidden={!hasCopiedLink}
                className={hasCopiedLink ? styles.inputContainer : styles.inputContainerHidden}
            >
                Lenken er kopiert!
            </div>
        </div>
    );
};

export default CopyLinkButton;
